import { useMemo, useState } from "react"
import { Link } from "@inertiajs/react"
import { FiArrowRight, FiCheck, FiCopy, FiMail } from "react-icons/fi"
import { AppLayout } from "../../components/AppLayout"

type Props = {
  customer_mode?: boolean
  card: {
    title: string
    subtitle: string | null
    public_url: string
    logo_url: string | null
    edit_url: string
  }
}

export default function Share({ card, customer_mode = false }: Props) {
  const [copied, setCopied] = useState(false)
  const signature = useMemo(() => {
    const title = escapeHtml(card.title)
    const logo = card.logo_url ? `<img src="${escapeHtml(card.logo_url)}" alt="${title}" width="48" height="48" style="border-radius:12px;object-fit:cover;vertical-align:middle;margin-left:12px;">` : ""
    return `<table dir="rtl" style="font-family:Arial,sans-serif;color:#0f172a"><tr><td>${logo}</td><td><strong style="font-size:16px">${title}</strong>${card.subtitle ? `<br><span style="color:#64748b">${escapeHtml(card.subtitle)}</span>` : ""}<br><a href="${escapeHtml(card.public_url)}" style="color:#0f766e">לכרטיס הדיגיטלי שלי</a></td></tr></table>`
  }, [card])

  const copySignature = async () => {
    await navigator.clipboard?.writeText(signature)
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1800)
  }

  return (
    <AppLayout title="חתימת אימייל" customerMode={customer_mode}>
      <div className="mx-auto max-w-3xl">
        <Link href={card.edit_url} className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800"><FiArrowRight aria-hidden="true" />חזרה לעריכה</Link>
        <div className="mt-5 flex items-start gap-3"><span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-50 text-brand-700"><FiMail size={22} aria-hidden="true" /></span><div><h1 className="text-2xl font-bold sm:text-3xl">חתימת אימייל</h1><p className="mt-1 text-slate-600">הוסיפו קישור לכרטיס בכל אימייל שאתם שולחים.</p></div></div>
        <section className="glass-card mt-6 p-5 sm:p-6">
          <h2 className="font-semibold">תצוגה מקדימה</h2>
          <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-5" dangerouslySetInnerHTML={{ __html: signature }} />
          <h2 className="mt-6 font-semibold">העתקת החתימה</h2>
          <p className="mt-1 text-sm text-slate-600">העתיקו את הקוד והדביקו אותו בהגדרות חתימת האימייל שלכם.</p>
          <pre className="mt-4 max-h-48 overflow-auto rounded-2xl bg-slate-900 p-4 text-left text-xs leading-6 text-slate-100" dir="ltr">{signature}</pre>
          <button type="button" onClick={copySignature} className="btn-primary mt-4 gap-2 bg-brand-600">{copied ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}{copied ? "הועתק" : "העתקת קוד החתימה"}</button>
        </section>
      </div>
    </AppLayout>
  )
}

function escapeHtml(value: string) {
  return value.replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character] || character)
}
